import { render, staticRenderFns } from "./alreadyShelves.vue?vue&type=template&id=4d84a3da&scoped=true"
import script from "./alreadyShelves.vue?vue&type=script&lang=js"
export * from "./alreadyShelves.vue?vue&type=script&lang=js"
import style0 from "./alreadyShelves.vue?vue&type=style&index=0&id=4d84a3da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d84a3da",
  null
  
)

export default component.exports